import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import ExchangePopoverItem from 'components/ExchangePopoverItem.js';
import ScheduleCounterTab from 'components/ScheduleCounterTab.js';
import Popover from 'components/popover/Popover.js';

class ScheduleAvailableShiftsCounter extends ScheduleCounterTab {
  constructor(props) {
    super(props);

    this._onCloseMyPopover = this._onCloseMyPopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
  }

  componentDidMount() {
    OffersStore.on(
      'offer:reply:success',
      function (collection, resposne) {
        const startDate = moment(new Date())
          .startOf('month')
          .format();
        const endDate = moment(new Date())
          .add(1, 'year')
          .format();
        this.setState({
          notificationData: OffersStore.getAllOfferedShifts(startDate, endDate, true),
        });
      },
      this,
    );

    OffersStore.on(
      'offer:cancel:success',
      function (collection, response) {
        const startDate = moment(new Date())
          .startOf('month')
          .format();
        const endDate = moment(new Date())
          .add(1, 'year')
          .format();
        this.setState({
          notificationData: OffersStore.getAllOfferedShifts(startDate, endDate, true),
        });
      },
      this,
    );

    ShiftStore.on(
      'all:shifts:load:success',
      function (response) {
        this.setState({
          notificationData: response.data.offered_shifts,
        });
      },
      this,
    );

    ShiftStore.on('shifts:load:error', this.dataErrorHandler, this);

    document.addEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onCloseMyPopover();
    }
  }

  _onCloseMyPopover() {
    if (this.state.popOverActive) {
      this.setState({
        popOverActive: false,
        popTarget: null,
      });
    }
  }

  componentWillUnmount() {
    ShiftStore.off(null, null, this);
    OffersStore.off(null, null, this);
    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  render() {
    this.state.notificationData.sort(
      (a, b) => parseFloat(moment(a.start_time).unix()) - parseFloat(moment(b.start_time).unix()),
    );

    const countBackgroundClass = `legend-item-count ${this.props.colorProperty}`;

    // this is next lvl code..
    let notificationCount = 0;
    if (!Utils.isNotDefined(this.state.notificationData)) {
      notificationCount = 0;
      for (let i = 0; i < this.state.notificationData.length; i++) {
        notificationCount++;
      }
    }

    const popClickHandler = this.onClickHandler.bind(this);

    return (
      <div onClick={e => this._onToggleMyPopover(e)}>
        <div className="legend-item" onMouseOver={this.handleRollOver}>
          <span className="legend-item-label">{this.props.notificationLabel}</span>
          <span className={countBackgroundClass}>{notificationCount}</span>
        </div>
        <Popover
          className="available-popover"
          onHide={this._onCloseMyPopover.bind(this)}
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
          position="top"
        >
          <h3>{this.props.t('ScheduleAvailableShiftsCounter.available_shifts')}</h3>
          <ul className="notificationsList">
            {this.state.notificationData.map((data) => {
              const startTime = moment(data.start_time)
                .tz(data.time_zone)
                .format('h:mm a');
              const endTime = moment(data.end_time)
                .tz(data.time_zone)
                .format('h:mm a');
              const viewOffers = data.replied 
                ? this.props.t('ScheduleAvailableShiftsCounter.cancel_request') 
                : this.props.t('ScheduleAvailableShiftsCounter.request_shift');
              const offerTitle = data.replied || data.replied == 'true'
                ? this.props.t('ScheduleAvailableShiftsCounter.shift_pending_approval')
                : this.props.t('ScheduleAvailableShiftsCounter.shift_waiting_for_you');
              const hideEnd = data.hide_end_time;

              const momentObj = moment(data.start_time).tz(data.time_zone);
              const selectDate = momentObj.format('YYYY-MM-DD');
              const shiftDate = Utils.formatLocaleDate(momentObj);

              return (
                <ExchangePopoverItem
                  key={_.uniqueId()}
                  title={offerTitle}
                  selectDate={selectDate}
                  shiftDate={shiftDate}
                  startTime={startTime}
                  clickHandler={e => popClickHandler(e)}
                  endTime={!hideEnd ? endTime : this.props.t('ScheduleAvailableShiftsCounter.tbd')}
                  shift_id={data.id}
                  viewOffers={viewOffers}
                />
              );
            })}
            {notificationCount === 0 &&
              <li style={{borderTop: 'none'}}><span>{this.props.t('ScheduleAvailableShiftsCounter.no_available_shifts')}</span></li>
            }
          </ul>
        </Popover>
      </div>
    );
  }
}

export default translate()(ScheduleAvailableShiftsCounter);
